// import { set } from "../../utils";
import { isAgent } from "../../utils/nick-utils";
import { ChatMemberJoinDetail } from "../ChatAction";
import { ChatState } from "../ChatState";
import { joinMessages } from "./joinMessages";
import { log } from "../../utils";

export function memberJoin(state: ChatState, detail: ChatMemberJoinDetail): ChatState {
    // TODO: Why?
    // if (state.chats.length === 0) {
        // console.log(`######### No chats in member join action`);
        // set("sessionId", "");
    // }

    const agents = { ...state.agents };
    const prevAgentInfo = state.agents[detail.user.nick];

    agents[detail.user.nick] = {
        ...prevAgentInfo,
        user: {
            ...detail.user,
            displayName: detail.user.displayName || "Agent",
        },
        joined: true,
        typing: false
    };

    if (isAgent(detail.user.nick)) {
        if (prevAgentInfo?.joined) {
            log(`DEDUPLICATION: Agent "${detail.user.displayName || "Unknown"}" (nick: ${detail.user.nick}) already joined. NOT adding duplicate join message to chat.`);
        } else {
            log(`Agent "${detail.user.displayName || "Unknown"}" (nick: ${detail.user.nick}) is joining. Adding join message to chat.`);
        }

        return {
            ...state,
            isChatting: true,
            chats: prevAgentInfo?.joined ? state.chats : joinMessages(state.chats, detail),
            agents
        };
    } else {
        log(`Non-agent member "${detail.user.displayName || "Unknown"}" (nick: ${detail.user.nick}) is joining. Adding join message to chat.`);
        return {
            ...state,
            isChatting: true,
            chats: joinMessages(state.chats, detail),
            agents
        };
    }
}
